export const AIR_PAYOUT_AMOUNT = 100;
export const AIR_LUGGAGE_AMOUNT = 100;
